<template>
  <CommonDrop
      ref="companyDrop"
    v-model="currentValue"
    url="/trade/company/list"
    :autoDefault="false"
    :filterable="true"
    :remote="true"
    :size="size"
    :clearable="clearable"
    :disabled="disabled"
  ></CommonDrop>
</template>
<script>
import CommonDrop from "@/components/CommonDrop";
export default {
  components: { CommonDrop },
  name: "company",
  props: {
    value: {
      type: String | Number,
      default: null,
    },
    size:{
      type:String,
      default:'mini'
    },
    clearable:{
      type:Boolean,
      default:false
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
      },
    },
  },
  methods: {
    getCompanyName(id){
      let c=this.$refs.companyDrop.dataList.find(item=>item.id==id);
      if(!c){return ''}
      return c.name
    }
  },
};
</script>
